import { AwsService } from "./../../../providers/appsyncservice/aws.service";
import { UserDetailsService } from "./../../../service/userdetails/user-details.service";
import { Component, OnInit } from "@angular/core";
import { formatDate } from "@angular/common";
import * as XLSX from "xlsx";

@Component({
  selector: "app-driver-feedback",
  templateUrl: "./driver-feedback.component.html",
  styleUrls: ["./driver-feedback.component.css"],
})
export class DriverFeedbackComponent implements OnInit {
  displayFeedbackValue = 0;
  errorMsg: string = "Loading... Please wait...";
  driverFeedbackList: any = [];
  driverFeedbackItem: any;
  driverDetails: any = {};
  userDetails: any = {};

  sortKey: string = "sno"; //set default
  sortReverse: boolean = false;
  noOfItems = 10;

  snoFilterModel: any = new Array();
  usernameFilterModel: any = new Array();
  nameFilterModel: any = new Array();
  driverUsernameFilterModel: any = new Array();
  driverNameFilterModel: any = new Array();
  ex_dataFilterModel: any = new Array();
  createdDateFilterModel: any = new Array();

  snoFilterData: any = [];
  usernameFilterData: any = [];
  nameFilterData: any[];
  driverUsernameFilterData: any = [];
  driverNameFilterData: any[];
  ex_dataFilterData: any[];
  createdDateFilterData: any[];

  dropdownSettings = {
    sno: {
      singleSelection: false,
      idField: "sno",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search S.No.",
    },
    username: {
      singleSelection: false,
      idField: "username",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN No.",
    },
    name: {
      singleSelection: false,
      idField: "name",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      searchPlaceholderText: "Search Name",
    },
    driver_username: {
      singleSelection: false,
      idField: "driver_username",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      searchPlaceholderText: "Search No.",
    },
    driver_display_name: {
      singleSelection: false,
      idField: "driver_display_name",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      searchPlaceholderText: "Search Name",
    },
    ex_data: {
      singleSelection: false,
      idField: "ex_data",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      searchPlaceholderText: "Search Status",
    },
    created_date: {
      singleSelection: false,
      idField: "created_date",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Date",
    },
  };
  that: any;

  constructor(
    private aws: AwsService,
    private userDetailservice: UserDetailsService
  ) {
    this.getDriverFeedbackList();
    this.that = this;
  }

  private async constructData(data) {
    console.log("CONSTRUCTDATE", data);
    this.driverFeedbackList = [];
    var oplist = [];
    for (var i in data) {
      var rsdata = data[i];
      data[i].sno = +i + 1;
      // var name;
      // if (rsdata.user_display_name == undefined) {
      //   var val = await this.userDetailservice.getDetails(rsdata.username);
      //   name = val.name;
      // } else {
      //   name = rsdata.user_display_name;
      // }
      data[i].username = rsdata.username;
      data[i].name = rsdata.user_display_name;
      data[i].driver_username =
        rsdata.driver_username == undefined ? "-" : rsdata.driver_username;
      data[i].driver_display_name =
        rsdata.driver_display_name == undefined
          ? "-"
          : rsdata.driver_display_name;
      data[i].sortField =
        rsdata.ex_data == "NEW"
          ? 9999999999999
          : new Date(rsdata.created_date).getTime();
      oplist.push(data[i]);
    }

    oplist = oplist.sort((a, b) => {
      if (a.sortField < b.sortField) {
        return 1;
      } else if (a.sortField > b.sortField) {
        return -1;
      }
    });
    this.driverFeedbackList = this.addSno(oplist);
  }

  private addSno(list: any[]): any[] {
    var ls: any[] = [];
    for (var rs in list) {
      var rsdata = list[rs];
      ls[rs] = rsdata;
      ls[rs].sno = +rs + 1;
    }
    return ls;
  }

  getDriverFeedbackList() {
    this.driverFeedbackList = [];
    this.errorMsg = "Loading... Please wait...";
    this.aws
      .getDriverFeedbackList()
      .then((res) => {
        console.log("driverFeedbackList", res.length);
        if (res.length > 0) {
          this.constructData(res);
        } else {
          this.errorMsg = "Sorry!. No feedback is found.";
        }
      })
      .catch((err) => {
        this.errorMsg = "Sorry!. Something went wrong! Try again!";
        console.log(err);
      });
  }
  ngOnInit() {}

  setDriverFeedbackDetail(item) {
    this.displayFeedbackValue = 1;
    this.driverFeedbackItem = item;
    console.log("driverFeedbackItem", this.driverFeedbackItem);
    this.aws.updateDriverFeedbackStat(item.id, "READ");
    this.aws
      .rnUserFilterById(item.driver_id)
      .then((res) => {
        console.log("rnUserFilterById" + item.driver_id, res);

        this.driverDetails = res;
      })
      .catch((err) => {
        console.log("rnUserFilterById", err);
      });
    this.aws.rnUserFilter(item.username).then((res) => {
      console.log("rnUserFilter", res);
      if (res.length > 0) {
        this.userDetails = res[0];
      }
    });
  }
  backButtonAction() {
    this.driverDetails = {};
    this.userDetails = {};
    this.displayFeedbackValue = 0;
    this.getDriverFeedbackList();
  }

  exportToExcel() {
    let exportJsonTemp = [];

    exportJsonTemp = this.excelDataFormation(this.driverFeedbackList);
    const workBook = XLSX.utils.book_new(); // create a new blank book

    const workSheet = XLSX.utils.json_to_sheet(exportJsonTemp);

    // ////console.log("EXCEL", exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, "data"); // add the worksheet to the book

    XLSX.writeFile(
      workBook,
      "Driver Feedback-" + new Date().getTime() + ".xlsx"
    );
  }

  excelDataFormation(list) {
    let dateFormat = require("dateformat");
    var otlist = [];
    console.log("-------- List  ", list);
    for (var l of list) {
      var r = {};
      r["Sno"] = l.sno;
      r["RN No."] = l.username;
      r["Name"] = l.name;
      r["Driver No."] = l.driver_username;
      r["Driver Name."] = l.driver_display_name;
      for (var q of l.questions_rating) {
        r[q.ques_name] = Number(q.rating);
      }
      r["Comments"] = l.comments;
      r["Feedback Date"] = dateFormat(l.created_date, "dd-mm-yyyy HH:MM:ss");
      otlist.push(r);
    }
    return otlist;
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return "fa fa-sort-desc";
      } else {
        return "fa fa-sort-asc";
      }
    } else {
      return "fa fa-sort";
    }
  }

  filterSearch(th, items, filter) {
    let result = items.filter((val) => {
      if (
        filter.sno.length == 0 &&
        filter.username.length == 0 &&
        filter.name.length == 0 &&
        filter.driver_username.length == 0 &&
        filter.driver_display_name.length == 0 &&
        filter.ex_data.length == 0 &&
        filter.created_date.length == 0
      ) {
        return true;
      } else {
        // if(filter.sno.indexOf(""+val.sno)>=0 && filter.username.indexOf(val.username)>=0 && filter.name.indexOf(val.name)>=0 && concernFound.length>0 && filter.request_id.indexOf(val.request_id)>=0 && filter.request_status.indexOf(val.request_status)>=0 && filter.created_date.indexOf(formatDate(val.created_date,'MMM dd, yyyy','en'))>=0)
        return (
          (filter.sno.length > 0
            ? filter.sno.indexOf("" + val.sno) >= 0
            : true) &&
          (filter.username.length > 0
            ? filter.username.indexOf(val.username) >= 0
            : true) &&
          (filter.name.length > 0
            ? filter.name.indexOf(val.name) >= 0
            : true) &&
          (filter.driver_username.length > 0
            ? filter.driver_username.indexOf(val.driver_username) >= 0
            : true) &&
          (filter.driver_display_name.length > 0
            ? filter.driver_display_name.indexOf(val.driver_display_name) >= 0
            : true) &&
          (filter.ex_data.length > 0
            ? filter.ex_data.indexOf(val.ex_data) >= 0
            : true) &&
          (filter.created_date.length > 0
            ? filter.created_date.indexOf(
                formatDate(val.created_date, "MMM dd, yyyy", "en")
              ) >= 0
            : true)
        );
      }
    });

    th.constructDropDownData(th, result, false);

    return result;
  }

  constructDropDownData(th, items, isData) {
    //  console.log("constructDropDownData",th.usernameFilterData);
    var snoData = [];
    var usernameData = [];
    var nameData = [];
    var driverUsernameData = [];
    var driverNameData = [];
    var StatusData = [];
    var createdDateData = [];

    for (var item of items) {
      console.log("username", item.sno, snoData.indexOf(item.sno));
      if (snoData.indexOf(item.sno) == -1) snoData.push("" + item.sno);
      if (usernameData.indexOf(item.username) == -1)
        usernameData.push(item.username);
      if (nameData.indexOf(item.name) == -1) nameData.push(item.name);
      if (driverUsernameData.indexOf(item.driver_username) == -1)
        driverUsernameData.push(item.driver_username);
      if (driverNameData.indexOf(item.driver_display_name) == -1)
        driverNameData.push(item.driver_display_name);
      if (StatusData.indexOf(item.ex_data) == -1) StatusData.push(item.ex_data);
      if (
        createdDateData.indexOf(
          formatDate(item.created_date, "MMM dd, yyyy", "en")
        ) == -1
      )
        createdDateData.push(
          formatDate(item.created_date, "MMM dd, yyyy", "en")
        );
    }

    console.log("constructDropDownData-", usernameData);
    if (isData) {
      th.snoFilterData = snoData;
      th.usernameFilterData = usernameData;
      th.nameFilterData = nameData;
      th.driverUsernameFilterData = driverUsernameData;
      th.driverNameFilterData = driverNameData;
      th.createdDateFilterData = createdDateData;
      th.ex_dataFilterData = StatusData;
    } else {
      setTimeout(() => {
        /*   th.snoFilterModel=snoData
      th.usernameFilterModel=usernameData;
       th.nameFilterModel=nameData;
       th.concenTypeFilterModel=concenTypeData.filter((item,index) => concenTypeData.indexOf(item) === index)
       th.requestIdFilterModel=requestIdData
       th.requestStatusFilterModel=requestStatusData
       th.createdDateFilterModel=createdDateData */

        th.snoFilterData = snoData;
        th.usernameFilterData = usernameData;
        th.nameFilterData = nameData;
        th.driverUsernameFilterData = driverUsernameData;
        th.driverNameFilterData = driverNameData;
        th.ex_dataFilterData = StatusData;
        th.createdDateFilterData = createdDateData;
      }, 0);
    }
  }
}
